(function (window, $, Argument, app) {
    function Collapse() {
        this.toggle = function (id, data) {
            group = Argument.get(data.group, false);

            var $collapse = $('#' + id);

            if (group) {
                console.log($('#' + group));

                $('#' + group).find('.collapse').not($collapse).removeClass('--open').find('.collapse\\/hidden').height('');
            }

            $collapse.toggleClass(function () {
                var $this = $(this);
                var state = ! $this.is('.\\--open');

                console.log($this);
                console.log($this.find('.collapse\\/hidden'));
                console.log(state);

                $this.find('.collapse\\/hidden').height(state ? $this.find('.collapse\\/content').outerHeight(true) : '');

                return '--open';
            });
        };
    }

    app.Collapse = new Collapse();
})(window, jQuery, Argument, Template3);
